export interface TipTypeEntry {
  id: 'reconocer' | 'crecer';
  icon: string;
  iconClass: string; // CSS class for icon background color
  labels: Record<string, string>;
  descriptions: Record<string, string>;
}

/**
 * Catalog of tip types with multilingual labels and descriptions.
 * No admin screen exists for this — edit directly here to add/rename types.
 */
export const TIP_TYPES: TipTypeEntry[] = [
  {
    id: 'reconocer',
    icon: 'fa-heart',
    iconClass: 'ttc-reconocer',
    labels: {
      es: 'Para Reconocer',
      en: 'To Recognize',
      pt: 'Para Reconhecer',
      fr: 'Pour Reconnaître',
      de: 'Zum Anerkennen',
      nl: 'Om te Erkennen',
      ro: 'Pentru a Recunoaște',
    },
    descriptions: {
      es: 'Panel de logros · caja verde clara + sugerencia oscura',
      en: 'Achievements panel · light green box + dark suggestion',
      pt: 'Painel de conquistas · caixa verde clara + sugestão escura',
      fr: 'Panneau de réalisations · boîte verte claire + suggestion sombre',
      de: 'Leistungspanel · helle grüne Box + dunkle Empfehlung',
      nl: 'Prestatiepaneel · lichtgroen vak + donkere suggestie',
      ro: 'Panou de realizări · casetă verde deschis + sugestie întunecată',
    },
  },
  {
    id: 'crecer',
    icon: 'fa-seedling',
    iconClass: 'ttc-crecer',
    labels: {
      es: 'Para Seguir Creciendo',
      en: 'To Keep Growing',
      pt: 'Para Continuar Crescendo',
      fr: 'Pour Continuer à Grandir',
      de: 'Um Weiter zu Wachsen',
      nl: 'Om te Blijven Groeien',
      ro: 'Pentru a Continua să Crești',
    },
    descriptions: {
      es: 'Sección de crecimiento · recuadro azul SIGUIENTE NIVEL',
      en: 'Growth section · blue NEXT LEVEL box',
      pt: 'Seção de crescimento · caixa azul PRÓXIMO NÍVEL',
      fr: 'Section croissance · encadré bleu NIVEAU SUIVANT',
      de: 'Wachstumsbereich · blauer NÄCHSTE STUFE-Kasten',
      nl: 'Groeisectie · blauw vak VOLGENDE NIVEAU',
      ro: 'Secțiunea de creștere · casetă albastră NIVELUL URMĂTOR',
    },
  },
];
